import { render, staticRenderFns } from "./Ddcx-detail.vue?vue&type=template&id=cc40b0f2&scoped=true&"
import script from "./Ddcx-detail.vue?vue&type=script&lang=js&"
export * from "./Ddcx-detail.vue?vue&type=script&lang=js&"
import style0 from "./Ddcx-detail.vue?vue&type=style&index=0&id=cc40b0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc40b0f2",
  null
  
)

export default component.exports